import { Outlet } from 'react-router-dom';
import { Footer } from './Footer';
import { Header } from './Header';

export function AppLayout() {
    return (
        <div className="min-vh-100 d-flex flex-column">
            <Header />
            <main className="site-main flex-grow-1">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
